import * as Sentry from '@sentry/browser';

export const captureException = ({ exception, module, during, payload }) => {
  Sentry.withScope((scope) => {
    scope.setExtras({
      module,
      during,
      payload,
    });
    Sentry.captureException(exception);
  });
};
